import React from 'react';

const ActiveUserTabContext = React.createContext({
  setSelectedTab: () => {}
});
export default ActiveUserTabContext;
